// Human-readable display names for language codes, keyed by both region-coded locales
// ("en-US") and bare language families ("en"). Split out of CovalVoiceConstants.ts to keep
// that file under the file-length policy baseline.
export const LANGUAGE_DISPLAY_MAP = {
  // Languages with region codes aka accents.
  "ar-XA": "Arabic",
  "bn-IN": "Bengali (India)",
  "bg-BG": "Bulgarian",
  "zh-HK": "Cantonese (Hong Kong)",
  "zh-CN": "Mandarin",
  "cs-CZ": "Czech",
  "da-DK": "Danish",
  "nl-BE": "Dutch (Belgium)",
  "nl-NL": "Dutch (Netherlands)",
  "en-AU": "English (Australia)",
  "en-IN": "English (India)",
  "en-GB": "English (UK)",
  "en-US": "English (USA)",
  "fi-FI": "Finnish",
  "fr-CA": "French (Canada)",
  "fr-FR": "French (France)",
  "de-DE": "German",
  "el-GR": "Greek",
  "gu-IN": "Gujarati",
  "hi-IN": "Hindi",
  "hu-HU": "Hungarian",
  "id-ID": "Indonesian",
  "it-IT": "Italian",
  "ja-JP": "Japanese",
  "kn-IN": "Kannada",
  "ko-KR": "Korean",
  "lv-LV": "Latvian",
  "lt-LT": "Lithuanian",
  "ml-IN": "Malayalam",
  "mr-IN": "Marathi",
  "nb-NO": "Norwegian",
  "pl-PL": "Polish",
  "pt-BR": "Portuguese (Brazil)",
  "ro-RO": "Romanian",
  "ru-RU": "Russian",
  "sr-RS": "Serbian",
  "sk-SK": "Slovak",
  "es-ES": "Spanish (Spain)",
  "es-US": "Spanish (Latin America)",
  "sw-KE": "Swahili",
  "sv-SE": "Swedish",
  "ta-IN": "Tamil",
  "te-IN": "Telugu",
  "th-TH": "Thai",
  "tr-TR": "Turkish",
  "uk-UA": "Ukrainian",
  "ur-IN": "Urdu",
  "vi-VN": "Vietnamese",
  // Languages without region codes aka accents.
  en: "English",
  de: "German",
  es: "Spanish",
  hi: "Hindi",
  ja: "Japanese",
  ko: "Korean",
  ar: "Arabic",
  zh: "Chinese",
}
